// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextField from '@/modules/common/components/TextField';
import DialogForm from '@/modules/common/components/DialogForm';
import SelectStatusInternal from '@/modules/common/components/SelectStatusInternal';
import { withFetch } from '~/hocs/fetch';

const initialValues = {
    code: '',
    status: '',
    internal: '0',
};

const initialErrors = {
    code: '',
    status: '',
    internal: '',
};

let abortController;

const DialogEdit = (props) => {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        if (props.selectedStatus) {
            setValues({
                code: props.selectedStatus.code,
                status: props.selectedStatus.status,
                internal: props.selectedStatus.internal.toString(),
            });
        }
    }, [props.selectedStatus]);

    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        setErrors({...errors, [prop]: ''});
    };

    const handleSubmit = (event) => {
        abortController = new AbortController();

        event.preventDefault();
        setFetching(true);
        props.fetch.put(`/api/statuses/${props.selectedStatus.id}/`, {...values}, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    clear();
                    props.onOk(data);
                }
                else {
                    let _errors = {...initialErrors};
                    _errors.code = (data.code) ? data.code[0] : '';
                    _errors.status = (data.status) ? data.status[0] : '';
                    _errors.internal = (data.internal) ? data.internal[0] : '';
                    setErrors(_errors);
                }
                setFetching(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setFetching(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const handleClose = () => {
        props.setOpen(false);
        clear();
        props.setSelectedStatus(null);
    };

    return (
        <DialogForm title="Изменение статуса" label="Изменить"
                    open={props.open} onClose={handleClose}
                    onSubmit={handleSubmit}
                    disabled={fetching}
        >
            <TextField label="Код" type="number" inputProps={{min: 0}}
                       value={values.code} onChange={handleChange('code')}
                       error={errors.code.length > 0}
                       helperText={errors.code}
                       onFocus={handleFocus('code')}
                       autoFocus={true}
            />
            <TextField label="Статус"
                       value={values.status} onChange={handleChange('status')}
                       error={errors.status.length > 0}
                       helperText={errors.status}
                       onFocus={handleFocus('status')}
            />
            <SelectStatusInternal value={values.internal} onChange={handleChange('internal')}
                                  showEmpty={false}
            />
        </DialogForm>
    );
};

DialogEdit.propTypes = {
    selectedStatus: PropTypes.object,
    setSelectedStatus: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogEdit;
Component = withFetch(Component);

export default Component;
